import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from './authStore';

/**
 * Route guard: renders the nested routes only for an authenticated user, otherwise redirects to
 * the login page (remembering the requested location). If the account is flagged as
 * must-change-password, the user is forced to the change-password page until they comply.
 */
export default function RequireAuth() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const mustChange = useAuthStore((s) => s.user?.mustChangePassword ?? false);
  const location = useLocation();

  if (!isAuthenticated) {
    // The driver app has its own sign-in (organisation, driver number, PIN).
    const signIn = location.pathname.startsWith('/drive') ? '/drive/sign-in' : '/login';
    return <Navigate to={signIn} replace state={{ from: location.pathname + location.search }} />;
  }

  if (mustChange && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return <Outlet />;
}
